import { ModalFooterProps } from "./types"
import { oysterClassNames } from "../utils/oysterClassNames"

export function ModalFooter({ children, className, ...rest }: ModalFooterProps) {
  const _className = oysterClassNames(
    "mt-4 flex items-center gap-3 px-4 md:px-5 md:justify-end border-t border-t-gray-200 pt-4",
    className,
  )

  return (
    <div className={_className} {...rest}>
      {children}
    </div>
  )
}
